/* ==========================================================================
   Leg Lush — chrome behaviour
   Progressive enhancement only. Every panel in this chrome is opened by a
   real checkbox, or by :hover / :focus-within in CSS, so the header still
   works with JavaScript switched off. This file layers on hover intent,
   ARIA state, Escape, scroll locking and the announcement rotator.
   Boot is idempotent so the Shopify theme editor can re-render sections.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DESKTOP = '(min-width: 1280px)';
  var BOUND = 'data-ll-bound';

  root.classList.add('ll-js');

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function bind(el) {
    if (!el || el.hasAttribute(BOUND)) return false;
    el.setAttribute(BOUND, '');
    return true;
  }
  function focusSafe(el) {
    if (!el) return;
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      el.focus();
    }
  }

  /* Live collections — re-read on every boot so editor swaps are picked up. */
  function allToggles() {
    return $$('.ll-toggle');
  }
  function allNavItems() {
    return $$('.ll-nav__item--has-menu');
  }

  /* ------------------------------------------------------------------
     Viewport width minus the scrollbar, for the full-bleed panels.
     ------------------------------------------------------------------ */
  function setViewportVar() {
    var w = root.clientWidth + 'px';
    $$('.ll-chrome').forEach(function (el) {
      el.style.setProperty('--ll-vw', w);
    });
  }

  /* ------------------------------------------------------------------
     Scroll lock, refcounted so drawer and search cannot fight.
     ------------------------------------------------------------------ */
  var lockCount = 0;
  var lockedScrollY = 0;

  function lockScroll() {
    if (lockCount++ > 0) return;
    lockedScrollY = window.scrollY;
    root.classList.add('ll-locked');
  }

  function unlockScroll() {
    if (lockCount === 0) return;
    if (--lockCount > 0) return;
    root.classList.remove('ll-locked');
    window.scrollTo(0, lockedScrollY);
  }

  /* ==================================================================
     1. Toggles — search overlay, mobile drawer, nested drawer panels
     ================================================================== */

  function onToggleChange(input) {
    var open = input.checked;
    input.setAttribute('aria-expanded', open ? 'true' : 'false');
    $$('label[for="' + input.id + '"]').forEach(function (l) {
      l.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // Mirror :checked onto a class so browsers without :has() still work.
    var openClass = input.getAttribute('data-open-class');
    var scopeSel = input.getAttribute('data-open-scope');
    if (openClass && scopeSel) {
      var scope = input.closest(scopeSel);
      if (scope) scope.classList.toggle(openClass, open);
    }

    if (input.hasAttribute('data-exclusive') && open) {
      allToggles().forEach(function (other) {
        if (other !== input && other.hasAttribute('data-exclusive') && other.checked) {
          other.checked = false;
          onToggleChange(other);
        }
      });
      closeAllMenus();
    }

    if (input.hasAttribute('data-lock')) {
      if (open) lockScroll();
      else unlockScroll();
    }

    // A nested drawer panel always starts at the top, not wherever you were.
    if (input.classList.contains('ll-drawer__toggle')) {
      var body = input.closest('.ll-drawer__body');
      if (body) body.scrollTop = 0;
    }

    if (open) {
      var focusSel = input.getAttribute('data-focus');
      if (focusSel) {
        var target = $(focusSel);
        if (target) window.requestAnimationFrame(function () {
          focusSafe(target);
        });
      }
    } else if (input.hasAttribute('data-reset')) {
      // Collapse nested panels so the drawer always reopens at the top level.
      $$(input.getAttribute('data-reset')).forEach(function (sub) {
        if (sub.checked) {
          sub.checked = false;
          onToggleChange(sub);
        }
      });
    }

    syncHeaderState();
  }

  function anyExclusiveOpen() {
    return allToggles().some(function (t) {
      return t.hasAttribute('data-exclusive') && t.checked;
    });
  }

  function closeExclusive() {
    var first = null;
    allToggles().forEach(function (t) {
      if (t.hasAttribute('data-exclusive') && t.checked) {
        if (!first) first = t;
        t.checked = false;
        onToggleChange(t);
      }
    });
    return first;
  }

  function initToggles() {
    allToggles().forEach(function (input) {
      if (!bind(input)) return;
      var controls = input.getAttribute('data-controls');
      input.setAttribute('role', 'button');
      input.setAttribute('aria-expanded', input.checked ? 'true' : 'false');
      if (controls) input.setAttribute('aria-controls', controls);

      // Space toggles a checkbox natively; give Enter the same behaviour.
      input.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        input.checked = !input.checked;
        onToggleChange(input);
      });

      input.addEventListener('change', function () {
        onToggleChange(input);
      });
    });

    // Labels acting as close buttons, back buttons and scrims.
    $$('label[data-ll-close], label[data-ll-back]').forEach(function (label) {
      if (!bind(label)) return;
      if (label.hasAttribute('data-ll-silent')) return;
      label.setAttribute('role', 'button');
      label.setAttribute('tabindex', '0');
      label.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          label.click();
        }
      });
    });
  }

  /* ==================================================================
     2. Desktop mega menu — hover intent, focus, Escape, veil
     ================================================================== */

  var openTimer = null;
  var closeTimer = null;

  function setItemOpen(item, open) {
    item.classList.toggle('is-open', open);
    var trigger = $('.ll-nav__link', item);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAllMenus(except) {
    allNavItems().forEach(function (item) {
      if (item !== except) setItemOpen(item, false);
    });
    updateVeil();
  }

  function updateVeil() {
    var open = allNavItems().some(function (item) {
      return item.classList.contains('is-open');
    });
    root.classList.toggle('ll-veiled', open);
    syncHeaderState();
  }

  function openMenu(item) {
    window.clearTimeout(closeTimer);
    window.clearTimeout(openTimer);
    if (!window.matchMedia(DESKTOP).matches) return;
    closeAllMenus(item);
    setItemOpen(item, true);
    updateVeil();
  }

  function initMenus() {
    allNavItems().forEach(function (item) {
      if (!bind(item)) return;
      var trigger = $('.ll-nav__link', item);
      var panel = $('.ll-mega', item);
      if (!trigger || !panel) return;

      trigger.setAttribute('aria-expanded', 'false');

      item.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        openTimer = window.setTimeout(function () {
          openMenu(item);
        }, 60);
      });

      item.addEventListener('mouseleave', function () {
        window.clearTimeout(openTimer);
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          setItemOpen(item, false);
          updateVeil();
        }, 160);
      });

      // Click / tap / Enter toggles, so touch devices get the panel too.
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (item.classList.contains('is-open')) {
          setItemOpen(item, false);
          updateVeil();
        } else {
          closeExclusive();
          openMenu(item);
        }
      });

      item.addEventListener('focusin', function () {
        if (!window.matchMedia(DESKTOP).matches) return;
        openMenu(item);
      });

      item.addEventListener('focusout', function (event) {
        if (item.contains(event.relatedTarget)) return;
        setItemOpen(item, false);
        updateVeil();
      });
    });

    var veil = $('.ll-veil');
    if (veil && bind(veil)) {
      veil.addEventListener('mouseenter', function () {
        closeAllMenus();
      });
      veil.addEventListener('click', function () {
        closeAllMenus();
      });
    }
  }

  /* ==================================================================
     3. Escape — closes the deepest open layer
     ================================================================== */

  function initEscape() {
    if (!bind(document.documentElement)) return;

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;

      var openSub = allToggles().filter(function (t) {
        return t.classList.contains('ll-drawer__toggle') && t.checked;
      });
      if (openSub.length) {
        var deepest = openSub[openSub.length - 1];
        deepest.checked = false;
        onToggleChange(deepest);
        focusSafe(deepest);
        return;
      }

      if (anyExclusiveOpen()) {
        focusSafe(closeExclusive());
        return;
      }

      var openItem = allNavItems().filter(function (item) {
        return item.classList.contains('is-open');
      })[0];
      if (openItem) {
        setItemOpen(openItem, false);
        updateVeil();
        focusSafe($('.ll-nav__link', openItem));
      }
    });

    // A click outside the header closes the desktop menus.
    document.addEventListener('click', function (event) {
      var header = $('.ll-header');
      if (!header || header.contains(event.target)) return;
      closeAllMenus();
    });

    window.addEventListener('scroll', onScroll, { passive: true });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        setViewportVar();
        if (window.matchMedia(DESKTOP).matches) closeExclusive();
        else closeAllMenus();
      }, 120);
    });
  }

  /* ==================================================================
     4. Sticky / transparent header state
     ================================================================== */

  var ticking = false;

  function syncHeaderState() {
    var header = $('.ll-header');
    if (!header) return;
    var scrolled = window.scrollY > 8;
    var forced =
      root.classList.contains('ll-veiled') ||
      anyExclusiveOpen() ||
      document.body.classList.contains('overflow-hidden');
    header.classList.toggle('is-solid', scrolled || forced);
    root.classList.toggle('ll-scrolled', scrolled);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      syncHeaderState();
      ticking = false;
    });
  }

  /* ==================================================================
     5. Announcement rotator — cross-fade, never a marquee
     ================================================================== */

  function initRotators() {
    $$('[data-ll-rotator]').forEach(function (rotator) {
      if (!bind(rotator)) return;
      var slides = $$('.ll-announce__slide', rotator);
      if (!slides.length) return;

      var index = 0;
      var timer = null;
      var delay = parseInt(rotator.getAttribute('data-interval'), 10) || 5000;
      var autoplay = rotator.getAttribute('data-autoplay') === 'true';

      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          $$('a', slide).forEach(function (a) {
            if (active) a.removeAttribute('tabindex');
            else a.setAttribute('tabindex', '-1');
          });
        });
      }

      function stop() {
        window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (!autoplay || slides.length < 2 || reduceMotion.matches) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, delay);
      }

      show(0);

      var prev = $('[data-ll-prev]', rotator);
      var next = $('[data-ll-next]', rotator);
      if (prev)
        prev.addEventListener('click', function () {
          show(index - 1);
          start();
        });
      if (next)
        next.addEventListener('click', function () {
          show(index + 1);
          start();
        });

      rotator.addEventListener('mouseenter', stop);
      rotator.addEventListener('mouseleave', start);
      rotator.addEventListener('focusin', stop);
      rotator.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });
      if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', start);

      start();
    });
  }

  /* ==================================================================
     6. Cart bubble — Dawn re-renders #cart-icon-bubble after every cart
        change with its own markup. Repaint it back into our icon.
     ================================================================== */

  function initCart() {
    var cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink || !cartLink.classList.contains('ll-header__action--cart')) return;
    if (!bind(cartLink)) return;

    var tpl = $('#ll-cart-icon-template');
    if (!tpl) return;
    var repainting = false;

    function repaint() {
      if (repainting) return;
      var dawnBubble = $('.cart-count-bubble', cartLink);
      if (!dawnBubble && $('.ll-cart-count', cartLink)) return;

      var count = 0;
      var n = dawnBubble && dawnBubble.querySelector('span[aria-hidden="true"]');
      if (n) count = parseInt(n.textContent.trim(), 10) || 0;

      repainting = true;
      cartLink.innerHTML = tpl.innerHTML;
      var bubble = $('.ll-cart-count', cartLink);
      var label = $('[data-ll-cart-label]', cartLink);
      if (bubble) {
        bubble.hidden = count === 0;
        var num = $('[data-ll-cart-number]', bubble);
        if (num) num.textContent = count < 100 ? String(count) : '99+';
      }
      if (label) label.textContent = count === 1 ? '1 item in cart' : count + ' items in cart';
      window.requestAnimationFrame(function () {
        repainting = false;
      });
    }

    new MutationObserver(repaint).observe(cartLink, { childList: true, subtree: true });
  }

  /* ==================================================================
     7. Boot
     ================================================================== */

  function boot() {
    initToggles();
    initMenus();
    initRotators();
    initCart();
    initEscape();
    setViewportVar();
    syncHeaderState();
  }

  boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function () {
    root.classList.remove('ll-veiled', 'll-locked');
    lockCount = 0;
  });
})();
